<p-card
	[header]="
		'presentation.app.page.settings.coach.general.biography.header' | translate
	"
	[style]="{ height: '100%' }"
	class="h-full"
	styleClass="h-full"
>
	<div [formGroup]="biographyForm">
		<ckeditor
			[config]="editorConfig$ | async"
			[editor]="editor"
			class="biography-editor"
			formControlName="biography"
		></ckeditor>
	</div>
</p-card>
